/*
 * @format
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, TabPanel } from '../TabsNew';

export default class TabItems extends React.Component {
    static propTypes = {
        tabs: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, content: PropTypes.node })),
        activeTabIndex: PropTypes.number,
        onActiveTabIndexChange: PropTypes.func
    };

    static defaultProps = {
        tabs: []
    };

    isControlled() {
        return this.props.activeTabIndex != null && typeof this.props.activeTabIndex === 'number';
    }

    render() {
        const { activeTabIndex, onActiveTabIndexChange, tabs } = this.props;
        if (!tabs.length) return null;

        const tabsProps = this.isControlled() ? {
            activeIndex: activeTabIndex,
            onChange: onActiveTabIndexChange
        } :
        {};

        return (
            <Tabs {...tabsProps}>
                {tabs.map((tab) => (
                    <TabPanel key={tab.label} label={tab.label}>
                        <div className="rec-full-content-wrap">{tab.content}</div>
                    </TabPanel>
                ))}
            </Tabs>
        );
    }
}
